import React from 'react'
import { Typogaphy } from 'vnetwork-ui'

interface ThreadStatusChangeProps {
    message: {
        type: string
        text?: string
        newStatus?: string
        [key: string]: any
    }
}

const ThreadStatusChange: React.FC<ThreadStatusChangeProps> = ({ message }) => {
    const statusColors = {
        OPEN: 'bg-green-50 border-green-200 text-green-800',
        CLOSED: 'bg-gray-50 border-gray-200 text-gray-800',
        PENDING: 'bg-yellow-50 border-yellow-200 text-yellow-800',
        DEFAULT: 'bg-purple-50 border-purple-200 text-purple-800',
    }

    const statusColor =
        statusColors[message?.newStatus as keyof typeof statusColors] ||
        statusColors.DEFAULT

    return (
        <div className="flex justify-center my-3">
            <div
                className={`border rounded-lg px-4 py-2 max-w-md ${statusColor}`}
            >
                <div className="flex items-center gap-2">
                    <svg
                        className="w-4 h-4 flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1}
                            d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                        />
                    </svg>
                    <Typogaphy className="text-xs font-medium">
                        Trạng thái: {message?.newStatus || 'Đã thay đổi'}
                    </Typogaphy>
                </div>
            </div>
        </div>
    )
}

export default ThreadStatusChange
